import FileIconCell from 'src/components/custom-cells/FileIconCell';
import { GridColumn } from 'src/components/GridWrapper';
import useInvoiceScanManager from 'src/hooks/useInvoiceScanManager';
import RenameFile from 'src/sections/invoice_scan_manager/invoice_scan_cell/RenameFile';
import ScannedOnCell from 'src/sections/invoice_scan_manager/invoice_scan_cell/ScannedOnCell';
import SourceCell from 'src/sections/invoice_scan_manager/invoice_scan_cell/SourceCell';
import { SourceFilterMenu } from 'src/sections/invoice_scan_manager/invoice_scan_cell/SourceFilterMenu';
import UploadedByCell from 'src/sections/invoice_scan_manager/invoice_scan_cell/UploadedByCell';
import UploadedOnCell from 'src/sections/invoice_scan_manager/invoice_scan_cell/UploadedOnCell';
import AttachedInvoiceCell from 'src/sections/invoice_scan_manager/ocr/ocr_cell/AttachedInvoiceCell';
import { FileIcon } from '../scan_manager/scanManagerColumns';

export const useInvoiceScanManagerColumns = () => {
  const { isOcrCompany } = useInvoiceScanManager();

  const invoiceScanManagerColumns: GridColumn<any>[] = [
    {
      field: 'selected',
      title: '',
      width: '30px',
    },
    {
      field: 'file',
      title: '',
      component: FileIconCell,
      headerCell: FileIcon,
      width: '50px',
      menu: false,
      sortable: false,
    },
    {
      field: 'originalFile',
      title: 'File Name',
      filter: 'text',
      dataType: 'string',
      component: RenameFile,
    },
    {
      field: 'invoiceNumber',
      title: 'Attached Document',
      filter: 'text',
      component: AttachedInvoiceCell,
      dataType: 'string',
      editable: false,
    },
    {
      field: 'createdBy',
      title: 'Uploaded By',
      filter: 'text',
      dataType: 'string',
      editable: false,
      component: UploadedByCell,
    },
    {
      field: 'creationDate',
      title: 'Uploaded On',
      filter: 'date',
      dataType: 'date',
      editable: false,
      component: UploadedOnCell,
    },
    {
      field: 'source',
      title: 'Source',
      filter: 'text',
      dataType: 'string',
      editable: false,
      component: SourceCell,
      columnMenu: SourceFilterMenu,
    },
    ...(!isOcrCompany
      ? []
      : ([
          {
            field: 'scannedOn',
            title: 'Scan Completed On',
            filter: 'date',
            editable: false,
            format: 'MM/dd/yyyy hh:mm a',
            dataType: 'date',
            component: ScannedOnCell,
          },
        ] as GridColumn<any>[])),
  ];

  return invoiceScanManagerColumns;
};

export default useInvoiceScanManagerColumns;
